import {
  METRIC_DATA_ADMIN_GET_LIST_INIT,
  METRIC_DATA_ADMIN_GET_LIST_SUCCESS,
  METRIC_DATA_ADMIN_GET_LIST_FAILURE,
  METRIC_DATA_ADMIN_GET_METRICS_LIST_INIT,
  METRIC_DATA_ADMIN_GET_METRICS_LIST_SUCCESS,
  METRIC_DATA_ADMIN_GET_METRICS_LIST_FAILURE,
  METRIC_DATA_ADMIN_GET_METRICS_GROUPS_WITH_DEFAULTS_INIT,
  METRIC_DATA_ADMIN_GET_METRICS_GROUPS_WITH_DEFAULTS_SUCCESS,
  METRIC_DATA_ADMIN_GET_METRICS_GROUPS_WITH_DEFAULTS_FAILURE,
  METRIC_DATA_ADMIN_DOWNLOAD_IMPORT_FILE_INIT,
  METRIC_DATA_ADMIN_DOWNLOAD_IMPORT_FILE_SUCCESS,
  METRIC_DATA_ADMIN_DOWNLOAD_IMPORT_FILE_FAILURE,
  METRIC_DATA_ADMIN_IMPORT_INIT,
  METRIC_DATA_ADMIN_IMPORT_SUCCESS,
  METRIC_DATA_ADMIN_IMPORT_FAILURE,
  METRIC_DATA_ADMIN_IMPORT_RESET,
  METRIC_DATA_ADMIN_GET_IMPORT_FILES_LIST_INIT,
  METRIC_DATA_ADMIN_GET_IMPORT_FILES_LIST_SUCCESS,
  METRIC_DATA_ADMIN_GET_IMPORT_FILES_LIST_FAILURE,
  METRIC_DATA_ADMIN_GET_CALCULATION_UNITS_INIT,
  METRIC_DATA_ADMIN_GET_CALCULATION_UNITS_SUCCESS,
  METRIC_DATA_ADMIN_GET_CALCULATION_UNITS_FAILURE,
  METRIC_DATA_ADMIN_GET_GROUPS_INIT,
  METRIC_DATA_ADMIN_GET_GROUPS_SUCCESS,
  METRIC_DATA_ADMIN_GET_GROUPS_FAILURE,
  METRIC_DATA_ADMIN_GET_DELETE_METRIC_DATA_INIT,
  METRIC_DATA_ADMIN_GET_DELETE_METRIC_DATA_SUCCESS,
  METRIC_DATA_ADMIN_GET_DELETE_METRIC_DATA_FAILURE,
  METRIC_DATA_ADMIN_GET_DELETE_METRIC_MARKS_DATA_INIT,
  METRIC_DATA_ADMIN_GET_DELETE_METRIC_MARKS_DATA_SUCCESS,
  METRIC_DATA_ADMIN_GET_DELETE_METRIC_MARKS_DATA_FAILURE,
  METRIC_DATA_ADMIN_EXPORT_METRICS_DATA_INIT,
  METRIC_DATA_ADMIN_EXPORT_METRICS_DATA_SUCCESS,
  METRIC_DATA_ADMIN_EXPORT_METRICS_DATA_FAILURE,
  METRIC_DATA_ADMIN_SAVE_INIT,
	METRIC_DATA_ADMIN_SAVE_SUCCESS,
	METRIC_DATA_ADMIN_SAVE_FAILURE,
	METRIC_DATA_ADMIN_SET_SAVE_DATA_BY_KEY,
	METRIC_DATA_ADMIN_SAVE_RESET,
	METRIC_DATA_ADMIN_DELETE_PREPARE_INIT,
	METRIC_DATA_ADMIN_DELETE_INIT,
	METRIC_DATA_ADMIN_DELETE_SUCCESS,
	METRIC_DATA_ADMIN_DELETE_FAILURE,
  METRIC_DATA_ADMIN_GET_PROCESSING_METRICS_NOTIFICATIONS_INIT,
  METRIC_DATA_ADMIN_GET_PROCESSING_METRICS_NOTIFICATIONS_SUCCESS,
  METRIC_DATA_ADMIN_GET_PROCESSING_METRICS_NOTIFICATIONS_FAILURE,
  METRIC_DATA_ADMIN_GET_PERIODS_LIST_INIT,
  METRIC_DATA_ADMIN_GET_PERIODS_LIST_SUCCESS,
  METRIC_DATA_ADMIN_GET_PERIODS_LIST_FAILURE,
  METRIC_DATA_ADMIN_SET_PERIOD_ID,
  METRIC_DATA_ADMIN_REFRESH_VIRTUAL_METRIC_DATA_INIT,
  METRIC_DATA_ADMIN_REFRESH_VIRTUAL_METRIC_DATA_SUCCESS,
  METRIC_DATA_ADMIN_REFRESH_VIRTUAL_METRIC_DATA_FAILURE,
  METRIC_DATA_ADMIN_SOFT_RESET,
  METRIC_DATA_ADMIN_RESET
} from './types';
import Constants from '../../../definitions/constants';
import ActionsTooling from '../../../tooling/actionsTooling';
import FilesTooling from '../../../tooling/filesTooling';
import { intl } from '../../../locales/localesConfig';

export function reset() {
  return {
    type: METRIC_DATA_ADMIN_RESET
  };
}

export function softReset() {
  return {
    type: METRIC_DATA_ADMIN_SOFT_RESET
  };
}

export function getList(params, paging = false) {
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: METRIC_DATA_ADMIN_GET_LIST_INIT,
      params: params,
      paging: paging
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/metric/getmetricsdata",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(METRIC_DATA_ADMIN_GET_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(METRIC_DATA_ADMIN_GET_LIST_FAILURE, error));
    }  
  };
}

export function getMetricsList() {
  let params = {
    mini_list_version: true, 
    order_fields: ["name"],
    order_directions: [Constants.crudGenerator.orderTypes.ASC],
    fields_are: ["active"],
    searches_are: [true],
    per_page: Constants.interface.fullListPageSize
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: METRIC_DATA_ADMIN_GET_METRICS_LIST_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/metric/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(METRIC_DATA_ADMIN_GET_METRICS_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(METRIC_DATA_ADMIN_GET_METRICS_LIST_FAILURE, error));
    }  
  };
}

export function getMetricsGroupsWithDefaults() {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(METRIC_DATA_ADMIN_GET_METRICS_GROUPS_WITH_DEFAULTS_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/metricsgroup/getmetricsgroupswithdefaults",
        "GET"
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(METRIC_DATA_ADMIN_GET_METRICS_GROUPS_WITH_DEFAULTS_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(METRIC_DATA_ADMIN_GET_METRICS_GROUPS_WITH_DEFAULTS_FAILURE, error));
    }  
  };
}

export function downloadImportFile(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(METRIC_DATA_ADMIN_DOWNLOAD_IMPORT_FILE_INIT));
    try {
      const resp = await FilesTooling.downloadFileClientSide(
        "/api/metric/downloadimportmetricdatafile",
        intl.formatMessage(
          { id: "common.entity.importFileName"}, 
          { entityNamePlural: intl.formatMessage({ id: "metricAdmin.entityNamePlural" } ) } 
        ),
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(METRIC_DATA_ADMIN_DOWNLOAD_IMPORT_FILE_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(METRIC_DATA_ADMIN_DOWNLOAD_IMPORT_FILE_FAILURE, error));
    }  
  };
}

export function importEntities(files, params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(METRIC_DATA_ADMIN_IMPORT_INIT));
    try {
      const resp = await FilesTooling.uploadMutipleFilesClientSide(
        "/api/metric/importmetricdata",
        files,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(METRIC_DATA_ADMIN_IMPORT_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(METRIC_DATA_ADMIN_IMPORT_FAILURE, error));
    }  
  };
}

export function getImportFilesList() {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(METRIC_DATA_ADMIN_GET_IMPORT_FILES_LIST_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/metric/getimportsfilelist",
        "GET"
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(METRIC_DATA_ADMIN_GET_IMPORT_FILES_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(METRIC_DATA_ADMIN_GET_IMPORT_FILES_LIST_FAILURE, error));
    }  
  };
}

export function getCalculationUnitsList(keyword, periodId) {
  let params = {
    mini_list_version: true, 
    order_fields: ["last_names", "first_names"],
    order_directions: [Constants.crudGenerator.orderTypes.ASC, Constants.crudGenerator.orderTypes.ASC],
    fields_are: [],
    searches_are: [],
    active: true,
    period_id: periodId,
    fields_like: [["last_names", "first_names", "code"]],
    searches_like: [keyword, keyword, keyword],
    per_page: Constants.interface.fullListPageSize
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: METRIC_DATA_ADMIN_GET_CALCULATION_UNITS_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/calculationunit/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(METRIC_DATA_ADMIN_GET_CALCULATION_UNITS_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(METRIC_DATA_ADMIN_GET_CALCULATION_UNITS_FAILURE, error));
    }  
  };
}

export function getGroupsList(periodId) {
  let params = {
    mini_list_version: true, 
    order_fields: ["name"],
    order_directions: [Constants.crudGenerator.orderTypes.ASC],
    fields_are: [],
    searches_are: [],
    active: true,
    period_id: periodId,
    per_page: Constants.interface.fullListPageSize
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: METRIC_DATA_ADMIN_GET_GROUPS_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/group/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(METRIC_DATA_ADMIN_GET_GROUPS_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(METRIC_DATA_ADMIN_GET_GROUPS_FAILURE, error));
    }  
  };
}

export function deleteMetricsData(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(METRIC_DATA_ADMIN_GET_DELETE_METRIC_DATA_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/metric/deletemetricsdata",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(METRIC_DATA_ADMIN_GET_DELETE_METRIC_DATA_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(METRIC_DATA_ADMIN_GET_DELETE_METRIC_DATA_FAILURE, error));
    }  
  };
}

export function deleteMetricsMarksData(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(METRIC_DATA_ADMIN_GET_DELETE_METRIC_MARKS_DATA_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/metric/deletemetricsmarksdata",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(METRIC_DATA_ADMIN_GET_DELETE_METRIC_MARKS_DATA_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(METRIC_DATA_ADMIN_GET_DELETE_METRIC_MARKS_DATA_FAILURE, error));
    }  
  };
}

export function exportMetricsData(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(METRIC_DATA_ADMIN_EXPORT_METRICS_DATA_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/metric/exportmetricsdata",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(METRIC_DATA_ADMIN_EXPORT_METRICS_DATA_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(METRIC_DATA_ADMIN_EXPORT_METRICS_DATA_FAILURE, error));
    }  
  };
}

export function save(data) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(METRIC_DATA_ADMIN_SAVE_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/metric/savemetricdata",
        "POST",
        null,
        data
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(METRIC_DATA_ADMIN_SAVE_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(METRIC_DATA_ADMIN_SAVE_FAILURE, error));
    }  
  };
}

export function setSaveDataByKey(key, value) {
  return {
    type: METRIC_DATA_ADMIN_SET_SAVE_DATA_BY_KEY,
    key: key,
    value: value
  };
}

export function resetSave(data) {
  return {
    type: METRIC_DATA_ADMIN_SAVE_RESET,
    data: data 
  };
}

export function prepareDelete(id) {
  return {
    type: METRIC_DATA_ADMIN_DELETE_PREPARE_INIT,
    id: id
  };
}

export function deleteMetricData(data) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(METRIC_DATA_ADMIN_DELETE_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/metric/deletemetricdata",
        "DELETE",
        null,
        data
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(METRIC_DATA_ADMIN_DELETE_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(METRIC_DATA_ADMIN_DELETE_FAILURE, error));
    }  
  };
}

export function getProcessingMetricsImportsNotifications(periodId, page = 1) {
  let params = {
    period_id: periodId,
    order_fields: ["created_at"],
    order_directions: [Constants.crudGenerator.orderTypes.DESC],
    per_page: Constants.interface.notificationsPageSize,
    page: page
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: METRIC_DATA_ADMIN_GET_PROCESSING_METRICS_NOTIFICATIONS_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/session/getprocessingmetricsimportnotifications",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(METRIC_DATA_ADMIN_GET_PROCESSING_METRICS_NOTIFICATIONS_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(METRIC_DATA_ADMIN_GET_PROCESSING_METRICS_NOTIFICATIONS_FAILURE, error));
    }  
  };
}

export function getPeriodsList() {
  let params = {
    mini_list_version: true, 
    order_fields: ["end_date", "created_at"],
    order_directions: [Constants.crudGenerator.orderTypes.DESC, Constants.crudGenerator.orderTypes.DESC],
    fields_are: ["active"],
    searches_are: [true],
    per_page: Constants.interface.fullListPageSize
  };
  return async (dispatch) => {
    dispatch(ActionsTooling.simpleActionFunction({
      type: METRIC_DATA_ADMIN_GET_PERIODS_LIST_INIT,
      params: params,
      paging: false
    }));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/period/list",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(METRIC_DATA_ADMIN_GET_PERIODS_LIST_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(METRIC_DATA_ADMIN_GET_PERIODS_LIST_FAILURE, error));
    }  
  };
}

export function refreshVirtualMetricData(params) {
  return async (dispatch) => {
    dispatch(ActionsTooling.defaultInitActionFunction(METRIC_DATA_ADMIN_REFRESH_VIRTUAL_METRIC_DATA_INIT));
    try {
      const resp = await ActionsTooling.defaultExpressApiCall(
        "/api/metric/refreshvirtualmetricdata",
        "POST",
        null,
        params
      );
      dispatch(ActionsTooling.defaultSuccessActionFunction(METRIC_DATA_ADMIN_REFRESH_VIRTUAL_METRIC_DATA_SUCCESS, resp));
    } catch (error) {
      dispatch(ActionsTooling.defaultErrorActionFunction(METRIC_DATA_ADMIN_REFRESH_VIRTUAL_METRIC_DATA_FAILURE, error));
    }  
  };
}


export function setPeriodId(id) {
  return {
    type: METRIC_DATA_ADMIN_SET_PERIOD_ID,
    id: id
  };
}

export function resetImport() {
  return {
    type: METRIC_DATA_ADMIN_IMPORT_RESET
  };
}


// WEBPACK FOOTER //
// ./source/client/actions/metricDataAdmin/index.js